   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')
    .filter("sanitize", sanitize); 

      sanitize.$inject = ['$sce']
      function sanitize($sce) { 
        return function(htmlCode){
        return $sce.trustAsHtml(htmlCode);
      }
  }; 